export enum Application {
    finance = 0,
    fleet = 1
}



// WEBPACK FOOTER //
// ./src/app/settings/enums/application.enum.ts